import api from '@/apis/di/accountingObjectAPI';
import Crud from '@/stores/crudBaseCache';
import indexedDB from '@/commons/indexedDB';

var crud = new Crud('accountingObjectCache', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_accounting_object',
    field: {
      key: 'accounting_object_id',
      code: 'accounting_object_code',
      name: 'accounting_object_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Xuất khẩu grid Danh sách cán bộ
   * @param {*} context
   * @param {*} payload
   * @returns
   * TVANH 10.02.2023
   */
  async exportEmployeeList(context, payload) {
    return await api.exportEmployeeList(payload);
  },

  /**
   * custom cache 100 bản ghi hay sử dụng nhất của danh mục KH, NCC và Cán bộ
   * dtnga3 (15.12.2023)
   * nmtuan4 22.12.2023
   */
  async loadFullCache({ dispatch, commit, getters }, payload) {
    if (!payload) {
      payload = {};
    }
    const indexDb = new indexedDB();
    const key = 'cacheDi_accountingObjectCache';
    const data = await indexDb.get(key);
    const config = getters[`_config`];
    if (data) {
      const { localData } = data;
      commit('setItems', localData);
    }
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
